/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="loader-container" v-if="showLoader" :style="styleDiv">
    <div class="lds-spinner">
      <svg-loader :fill="color" />
    </div>
  </div>
</template>

<script>
import SvgLoader from 'theme/components/AbsoluteLoader/SvgLoader'

export default {
  name: 'AbsoluteLoader',
  props: {
    showLoader: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: String,
      default: '100%'
    },
    mode: {
      type: String,
      default: 'absolute'
    },
    color: {
      type: String,
      required: false,
      default: '#000'
    }
  },
  computed: {
    styleDiv () {
      return {
        minHeight: this.minHeight,
        position: this.mode
      }
    },
    isVisible () {
      return this.$store.state.ui.loader
    }
  },
  components: {
    SvgLoader
  }
}
</script>
